/*
 * Module for the _Member partial view
*/

rs.module("content/employer/reporting/maintenance/member",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var newHireCheckbox = form.js(jsSelectors.newHireCheckbox);
            var reHireCheckbox = form.js(jsSelectors.reHireCheckbox);
            var samePersonCheckbox = form.js(jsSelectors.samePersonCheckbox);
            var differentPersonCheckbox = form.js(jsSelectors.differentPersonCheckbox);

            // uncheck re hire if new hire is checked
            newHireCheckbox.change(function () {
                if ($(this).is(':checked')) {
                    reHireCheckbox.setChecked(false);
                }
            });

            // uncheck new hire if re hire is checked
            reHireCheckbox.change(function () {
                if ($(this).is(':checked')) {
                    newHireCheckbox.setChecked(false);
                }
            });

            // uncheck different person if same person is checked
            samePersonCheckbox.change(function () {
                if ($(this).is(':checked')) {
                    differentPersonCheckbox.setChecked(false);
                }
            });

            // uncheck same person if different person is checked
            differentPersonCheckbox.change(function () {
                if ($(this).is(':checked')) {
                    samePersonCheckbox.setChecked(false);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);